import script from "./TiktokWebhookDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TiktokWebhookDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./TiktokWebhookDeleteDialog.vue?vue&type=style&index=0&id=cb1905f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb1905f6"]])

export default __exports__